import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";
import { UserService } from "@/services";

const PersonalStatus = () =>
  import(
    /* webpackChunkName: "PersonalStatus" */ "@/components/AccountPage/Personal/PersonalStatus/index"
  );

const PersonalIdentity = () =>
  import(
    /* webpackChunkName: "PersonalIdentity" */ "@/components/AccountPage/Personal/PersonalIdentity/index"
  );

const PersonalKycStatus = () =>
  import(
    /* webpackChunkName: "PersonalKycStatus" */ "@/components/AccountPage/Personal/PersonalKycStatus/index"
  );

const PersonalContact = () =>
  import(
    /* webpackChunkName: "PersonalContact" */ "@/components/AccountPage/Personal/PersonalContact/index"
  );

const AutoVerification = () =>
  import(
    /* webpackChunkName: "AutoVerification" */ "@/components/AccountPage/Personal/AutoVerification/index"
  );

export default {
  name: "personal",
  components: {
    PersonalStatus,
    PersonalIdentity,
    PersonalKycStatus,
    PersonalContact,
    AutoVerification
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      userInfo: types.userInfo.getters.GET_USER_INFO,
      userVerifyInfo: types.userVerifyInfo.getters.GET_USER_VERIFY_INFO
    }),

    contactInfo() {
      return {
        mobile: this.userInfo?.mobile,
        phone: this.userInfo?.phone,
        email: this.userInfo?.email
      };
    },

    rejectReason() {
      return this.userVerifyInfo?.verification_image?.reject_reason;
    }
  },
  watch: {
    $route: {
      handler: function() {
        this.getAuthVerifyInfo();
        this.getUserInfo();
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {},
  methods: {
    ...mapActions({
      setUserData: types.userInfo.actions.ACTION_USER_INFO,
      setVerifyData: types.userVerifyInfo.actions.SET_USER_VERIFY_INFO
    }),
    getAuthVerifyInfo() {
      UserService.getVerifyInfo().then(response => {
        this.setVerifyData(response.data.data);
      });
    },
    getUserInfo() {
      UserService.getInfo().then(response => {
        this.setUserData(response.data.data);
      });
    }
  }
};
